module.exports = {
    common:{
        more:'更多',
        pageview:'人浏览',
        nodata:'没有数据',
        next:'下一步',
        back:'返回',
        edit:'编辑',
        deletes:'删除',
        submit:'提交',
        logout:'退出',
        phoneCountry:'国码',
        phoneArea:'区号',
        login: ' 注册&登录 ',
        mobile: '手机号',
        code: '验证码',
        email: '邮箱',
        userLogin: '请输入预登记信息注册&登录',
        pleaseFillOut: '请填写',
        userinfo: "个人信息",
        question: '问卷',
        colleagues: '同事',
        confirmation: '确认函',
        isRequired: '标记 <span class="required">*</span> 为必填项',
        fillInAgain: '重新填写',
        userCenter: '进入个人中心',
        save: '保存',
        success: '成功',
        invite: '邀请',
        continues: '继续',
        makeSure: '确定退出登录吗？',
        tip: '提示',
        ok: '确定',
        cancel: '取消',
        isloading: '正在加载...',
        isSubmit: '正在提交',
        agree: '我已阅读并同意相关条款',
        privacyClause: '请勾选隐私条款',
        other: '其他（请说明）'
    },
    usercenter: {
        useredit: '编辑个人资料',
        more:'更多',
        subtitle:'确认函',
    },
    infomenu:{
        person:'个人资料',
        category:'问卷调查'
    },
    question:{
        required:'必填',
        childrequired:'请选择子问题',
        txtrequired:'请填写文本框内容',
        country:'国家',
        state:'省份'
    },
    payment:{
        name:'姓名',
        name1: '姓名（与身份证一致）',
        money:'金额',
        state:'状态',
        promocode:'优惠码',
        submit:'提交',
        selall:'全选',
        totalmoney:'付款总金额',
        paynow:'立即支付',
        btnskip:'下一步',
        selpaytype:'请选择付款方式',
        paid:'已支付',
        unpaid:'未支付',
        company:'公司',
        audited:'审核通过',
        unaudited:'待审核',
        auditfail:'审核失败',
        used:'优惠码使用成功！',
        wxpay:'微信付款',
        alipay:'支付宝付款',
        jdpay:'银联支付',
        asia:'Asia Pay',
    },
    colleague:{
        continueinv:'继续邀请',
        addcoll:'推荐同事',
    },
	login: {
		loginFail: '登录失败',
    logining: '正在登录...'
	}
}



// WEBPACK FOOTER //
// ./src/common/lang/zh.js